import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import api from '../../api/axios';
import Topbar from '../layout/Topbar';
import { useBookStore } from '../../provider/BookStore';
import { useMasterStore } from '../../provider/MasterStore';

const Category = () => {

    const bookState = useBookStore();
    const book = bookState.book;
    const state = {state:{book:book}};
    const [debitCategories, setDebitCategories] = useState([]);
    const [kreditCategories, setKreditCategories] = useState([]);
    const [isLoading, setLoading] = useState(false);
    const navigate = useNavigate();
    // cache master data — halaman ini sumber kebenaran saat add/edit/delete
    const masterStore = useMasterStore();

    useEffect(() => {
        console.log(book);
        getCategories();
    }, []);

    const getCategories = async () => {
        // halaman manajemen: selalu ambil data terbaru (force),
        // sekaligus meng-update cache untuk halaman lain
        setLoading(true)
        const cats = await masterStore.loadCategories(book.id, { force: true });
        if (cats) {
            setDebitCategories(cats.debit)
            setKreditCategories(cats.kredit);
        }
        setLoading(false)
    }

    const addCategory = () => {
        console.log(book.id);
        navigate('/category/add', state)
    }

    const editCategory = (category) => {
        navigate('/category/add', {
            state:{
                book:book,
                data:category,
                action:'edit'
            }
        })
    }

    

    return (
        <div>
            <Topbar
                title={'Kategori'}
                back={()=>navigate('/book')}
                isLoading={isLoading}
            />
            <div className='container p-5'>

                <div className="columns is-centered">
                    <div className="column is-5-widescreen is-6-desktop is-7-tablet">

                        <button className='button is-floating is-primary' onClick={() => addCategory()}>
                            <span className='icon has-text-white'><i className="fa fa-plus"></i></span>
                        </button>

                        <p className='is-size-6 mb-4'>Buku Kas : {book.title}</p>

                        <div className='card'>
                            <header className='card-header'>
                                <p className='card-header-title'>Debit</p>
                            </header>
                            <div className='card-content'>
                            {debitCategories.map((item,index) => (
                                <div key={index} onClick={()=>editCategory(item)}>
                                    <div className='is-clearfix'>
                                        <div className='is-pulled-left'>
                                            <p className=''> {item.title}</p>
                                        </div>

                                    </div>
                                    <hr/>
                                </div>
                            ))}
                            </div>
                        </div>
                        <div className='card'>
                            <header className='card-header'>
                                <p className='card-header-title'>Kredit</p>
                            </header>
                            <div className='card-content'>
                            {kreditCategories.map((item,index) => (
                                <div key={index}  onClick={()=>editCategory(item)}>
                                    <div className='is-clearfix'>
                                        <div className='is-pulled-left'>
                                            <p className=''> {item.title}</p>
                                        </div>

                                    </div>
                                    <hr/>
                                </div>
                            ))}
                            </div>
                        </div>
                        

                    </div>
                </div>

            </div>
        </div>
    )
}

export default Category
